module.exports = __webpack_public_path__ + "img/animal-penngin.e9e736fe.png";